import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';

import * as ficheActions from 'redux/modules/fiches';

import { initializeWithKey } from 'redux-form';

import { Legende } from 'components';

import { ReduxAsyncConnect, asyncConnect, reducer as reduxAsyncConnect } from 'redux-connect';
import { isLoaded as areFichesLoaded, load as loadFiches } from 'redux/modules/fiches';
import { isLoaded as areGroupsLoaded, load as loadGroups } from 'redux/modules/groups';

import { DeleteButton } from 'components';

import { LinkContainer } from 'react-router-bootstrap';

var _ = require('underscore');
require('./geosuggest.css');


import { paginationFunc } from 'utils/pagination';

import { analyseState } from 'utils/analyseState';
import { translate } from 'react-i18next';

@translate(['common'])
@asyncConnect([{
	key: 'Fiches',
	promise: ({ store: { dispatch, getState }, params }) => {
		const promises = [];

		if (!areFichesLoaded(getState())) {
			promises.push(dispatch(loadFiches(1, params)));
		}
		if (!areGroupsLoaded(getState())) {
			promises.push(dispatch(loadGroups(params)));
		}

		return Promise.all(promises);
	}
}])
@connect(
	state => ({
		fiches: state.fiches.data,
		editing: state.fiches.editing,
		error: state.fiches.error,
		loading: state.fiches.loading,
		groups: state.groups.data,
		fichesNb: state.fiches.fichesNb,
		currentPage: state.fiches.currentPage,
		pages: state.fiches.pages,
		SMSLoading: state.fiches.SMSLoading,
		user: state.auth.user,
	}),
	{ ...ficheActions, initializeWithKey })

export default class Fiches extends Component {

	componentDidMount() {
		this.props.cancelEdit();
	}

	render() {

		const handleEdit = (fiche) => {
			const { editStart } = this.props; // eslint-disable-line no-shadow
			return () => editStart(fiche.id);
		};

		const handleDelete = (fiche) => {
			const { deleteFiche } = this.props; // eslint-disable-line no-shadow
			return () => deleteFiche(fiche, this.props.params);
		};

		const handleLoad = (page) => {
			const { load } = this.props; // eslint-disable-line no-shadow
			return () => load(parseInt(page), this.props.params);
		};

		const handleSendSMS = (fiche) => {
			const { sendSMS } = this.props; // eslint-disable-line no-shadow
			return () => sendSMS(fiche, this.props.params);
		};

		const { fiches, error, editing, loading, load, save,
			pages, fichesNb, currentPage, clearFiches, SMSLoading, user } = this.props;

		let refreshClassName = 'fa fa-refresh';
		if (loading) {
			refreshClassName = 'fa fa-refresh fa-spin';
		}
		const styles = require('./Fiches.scss');

		var paginationObj = paginationFunc(currentPage, pages);
		var pagination = [];

		for (var a in paginationObj) {
			var item = paginationObj[a];
			var className = (currentPage == item ? ' active' : '');
			pagination.push(<li className={className} onClick={handleLoad(item)}><a>{item}</a></li>)
		}

		var fiches_rows = [];
		var content = [];

		if (fiches && _.size(fiches) > 0) {
			for (var id in fiches) {
				var fiche = fiches[id];
				var groups = fiche.groups.map((g) => {
					return g.name;
				}).join(', ');

				if (groups.length > 30) {
					groups = groups.substring(0, 30) + '...';
				}
				var color = '';

				var requiredFields = [/*'identification_GSM', */'identification_NUM_ASC', 'identification_ID', 'localisation_adresse']

				var products_validations = [];

				if (fiche.products.length > 0) {
					_.each(fiche.products, function (p) {
						var has_all_required = true;
						_.each(requiredFields, function (field) {

							if (p[field] == '') {
								has_all_required = false;
							}
						});
						products_validations.push(has_all_required)
					})
				}
				//Si au moins un produit a tous les paramètres requis
				if (_.indexOf(products_validations, true) > -1) {
					color = 'orange';
				} else {
					color = 'black';
				}

				var state = analyseState(fiche.etat);
				if (state['asts1'].state == 3) {
					color = 'blue';
				}

				var editFichePath = user.role == 'admin' ?
					'/' + this.props.params.role + '/' + this.props.params.id + '/fiche/' + fiche.id + '/edit' :
					'/client/fiche/' + fiche.id + '/edit';

				var products = fiche.products.map((p) => {
					return <div>
						<b>{t('main.help')}ID PTU : </b>{p.identification_ID}<br />
						&nbsp;&nbsp;{p.localisation_adresse}
					</div>
				});

				fiches_rows.push(
					<tbody>
						<tr key={fiche.id}>
							<td><i className="fa fa-circle" style={{ color: color }}></i></td>
							<td>{fiche.creation}</td>
							<td>{fiche.gsm}</td>
							<td>{fiche.localisation_prestataire}</td>
							<td>
								{products}
							</td>
							<td>
								{groups}
							</td>
							<td className={styles.buttonCol}>
								<LinkContainer to={editFichePath}>
									<button className="btn btn-primary">
										<i className="fa fa-pencil" />
									</button>
								</LinkContainer>
								&nbsp;
	              				<DeleteButton callback={() => { this.props.deleteFiche(fiche, this.props.params) }} />
								&nbsp;
	             				<button className="btn btn-warning" disabled={SMSLoading} onClick={handleSendSMS(fiche)}>
									<i className="fa fa-envelope-o" />
								</button>
							</td>
						</tr>

					</tbody>
				);
			}
			content.push(
				<div className="table-responsive">
					<table className="table table-striped">
						<thead>
							<tr>
								<th>{t('main.state')}</th>
								<th>{t('main.creation_date')}</th>
								<th>{t('main.phone')}</th>
								<th>{t('main.prestataire')}</th>
								<th>{t('main.products')}</th>
								<th>{t('main.groups')}</th>
								<th>{t('main.actions')}</th>
							</tr>
						</thead>
						{fiches_rows}
					</table>
				</div>);
		} else {
			content.push(<span></span>);
		}

		if (fichesNb > 10) {
			content.push(
				<nav>
					<ul className="pagination">
						<li><a href="#" aria-label="Previous" onClick={handleLoad(currentPage > 1 ? currentPage - 1 : 1)}><span aria-hidden="true">«</span></a></li>
						{pagination}
						<li><a href="#" aria-label="Next" onClick={handleLoad(currentPage < pages ? currentPage + 1 : currentPage)}><span aria-hidden="true">»</span></a></li>
					</ul>
				</nav>
			);
		}

		var cid = this.props.params.id
		var addUrl = cid != undefined ? '/admin/fiches/' + cid + '/create' : '/client/addfiche';

		return (
			<div className={styles.fiches + ' container'}>
				<div>
					<h1>Fiches&nbsp;
	          			<button className={styles.refreshBtn + ' btn btn-success'} onClick={handleLoad(currentPage)}>
							<i className={refreshClassName} /> {' '}
						</button>
						&nbsp;
	         			<LinkContainer to={addUrl}>
							<button className={styles.refreshBtn + ' btn btn-primary'}>
								<i className='fa fa-wpforms' /> {' '} {t('main.create_sheet')}
		          			</button>
						</LinkContainer>
					</h1>
				</div>

				<Legende />

				<Helmet title={t('main.sheets')}/>

				{content}
				{error &&
					<div className="alert alert-danger" role="alert">
						<span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
						{t('main.connection_error')}
					</div>}
			</div>
		);
	}
}